import React from "react";
import { ResourceAvatar } from "@common/resourceAvatar";
import { ListToggleArrow } from "@common/listToggleArrow";
import { resource, ResourceTypes } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";
import { useToggle } from "@common/treeToggle";

function Resource({ workLoad }: Props) {
  const { isOpen, toggle } = useToggle(workLoad.uuid, 0, false);

  return (
    <div className={styles.resource}>
      <div className={styles.iconBox} onClick={toggle}>
        <ListToggleArrow isOpen={isOpen} />
      </div>
      <div className={styles.avatar}>
        <ResourceAvatar
          resource={{
            ...resource,
            name: workLoad.resourceName,
            type: workLoad.resourceType as ResourceTypes,
          }}
        />
      </div>
      <p className={styles.name}>{workLoad.resourceName}</p>
    </div>
  );
}

export { Resource };
